<div
  class="table-container"
  [formGroup]="donationFormGroup"
  >
  <mat-table
    formArrayName="donations"
    class="uw-table"
    [dataSource]="formTableDataSource"
    style="table-layout: auto"
    matSort
    (matSortChange)="onSortChange($event)"
    matSortActive="amount"
    matSortDirection="asc"
    >
    <ng-container matColumnDef="donorName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{
        columnsConfigMap.donorName?.label ??
        "paid_unpaid_transaction_list_columns.donorName" | translate
        }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.get('donorName').value }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="employeeNo">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{
        columnsConfigMap.employeeNo?.label ??
        "paid_unpaid_transaction_list_columns.employeeNo" | translate
        }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{ element.get('employeeNo').value }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="paymentFrequency">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{
        columnsConfigMap.paymentFrequency?.label ??
        "paid_unpaid_transaction_list_columns.paymentFrequency" | translate
        }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.get('paymentFrequency').value }}</mat-cell
        >
      </ng-container>
      <ng-container matColumnDef="paymentMethod">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{
          columnsConfigMap.paymentMethod?.label ??
          "paid_unpaid_transaction_list_columns.paymentMethod" | translate
          }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.get('paymentMethod').value | translate }}</mat-cell
          >
        </ng-container>

        <ng-container matColumnDef="donationAmount">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
            columnsConfigMap.donationAmount?.label ??
            "paid_unpaid_transaction_list_columns.donationAmount" | translate
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{
            element.get('donationAmount').value
            | currency: "":"symbol-narrow":"1.2-2":currentLanguage
            }}</mat-cell
            >
          </ng-container>
          <ng-container matColumnDef="donationDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              {{
              columnsConfigMap.donationDate?.label ??
              "paid_unpaid_transaction_list_columns.donationDate" | translate
              }}
            </mat-header-cell>
            <mat-cell
              class="p-1 m-1"
              *matCellDef="let element; let rowIndex = index"
              [formGroup]="element"
              >
              <!-- {{element.donationDate}} -->
              @if (columnsConfigMap.donationDate?.fieldType === 'readonly') {
                <span>
                  {{ element.get('donationDate').value | date: "dd/MM/yyyy" }}
                </span>
              }
              <div class="pr-4">
                @if (columnsConfigMap.donationDate?.fieldType === 'form') {
                  <input
                    id="choose_date"
                    type="text"
                    class="uw-input"
                    (click)="picker.open()"
                    [matDatepicker]="picker"
                    formControlName="donationDate"
                    />
                }
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="billingDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              {{
              columnsConfigMap.billingDate?.label ??
              "paid_unpaid_transaction_list_columns.billingDate" | translate
              }}
            </mat-header-cell>
            <mat-cell
              class="p-1 m-1"
              *matCellDef="let element; let rowIndex = index"
              [formGroup]="element"
              >
              <!-- <span *ngIf="element.paid === 'unpaid and uploaded'">{{element.billingDate}}</span> -->
              <!-- {{element.billingDate}} -->
              @if (element.get('paid').value != 'unpaid and uploaded') {
                <input
                  id="choose_date"
                  type="text"
                  class="uw-input"
                  (click)="billDatePicker.open()"
                  [matDatepicker]="billDatePicker"
                  formControlName="billingDate"
                  />
              }
              <mat-datepicker #billDatePicker></mat-datepicker>
            </mat-cell>
          </ng-container>
          <!-- <ng-container matColumnDef="received">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
            columnsConfigMap.received?.label ??
            "paid_unpaid_transaction_list_columns.received" | translate
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span *ngIf="element.get('received').value">{{ "common.yes" | translate }}</span>
            <span *ngIf="!element.get('received').value">{{ "common.no" | translate }}</span>
          </mat-cell>
        </ng-container> -->

        <ng-container matColumnDef="received">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
            columnsConfigMap.received?.label ??
            "paid_unpaid_transaction_list_columns.received" | translate
            }}
            <mat-checkbox
              class="ml-2"
              (change)="$event ? toggleAllRows('received', receivedColumnSelection.selected.length) : null"
              [checked]="receivedColumnSelection.hasValue() && isAllSelected(receivedColumnSelection.selected.length)"
              [indeterminate]="receivedColumnSelection.hasValue() && !isAllSelected(receivedColumnSelection.selected.length)"
              [attr.aria-label]="checkboxLabel(receivedColumnSelection)"
              >
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row; let rowIndex = index"
            [formGroup]="row"
            >
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? receivedColumnSelection.toggle(row) : null"
              [checked]="receivedColumnSelection.isSelected(row)"
              [attr.aria-label]="checkboxLabel(receivedColumnSelection, row)"
              formControlName="received"
            ></mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="paid">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
            columnsConfigMap.paid?.label ??
            "paid_unpaid_transaction_list_columns.paid" | translate
            }}
            <mat-checkbox
              class="ml-2"
              (change)="$event ? toggleAllRows('paid', selection.selected.length) : null"
              [checked]="selection.hasValue() && isAllSelected(selection.selected.length)"
              [indeterminate]="selection.hasValue() && !isAllSelected(selection.selected.length)"
              [attr.aria-label]="checkboxLabel(selection)"
              [disabled]="isWorkspaceAdmin"
              >
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row; let rowIndex = index"
            [formGroup]="row"
            >
            <!-- <span *ngIf="row.paid === 'unpaid and uploaded'">{{row.paid}}</span> -->
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
              [attr.aria-label]="checkboxLabel(selection, row)"
              formControlName="paid"
            ></mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="envelopeNo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{
            columnsConfigMap.envelopeNo?.label ??
            "paid_unpaid_transaction_list_columns.envelopeNo" | translate
            }}
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element; let rowIndex = index"
            [formGroup]="element"
            >
            <input
              id="envelope-no"
              type="text"
              class="uw-input"
              placeholder=""
              [value]="element.envelopeNo"
              formControlName="envelopeNo"
              />
            </mat-cell>
          </ng-container>

          <mat-header-row
            *matHeaderRowDef="columnsConfig.displayedColumns; sticky: true"
          ></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: columnsConfig.displayedColumns"
          ></mat-row>
        </mat-table>
        <mat-paginator
          (page)="onPageChange($event)"
          [pageSizeOptions]="[10, 20, 30]"
          showFirstLastButtons
          [attr.aria-label]=""
          >
        </mat-paginator>
      </div>

      <!-- <pre>{{ donationFormGroup?.value | json }}</pre> -->
